module.exports = __webpack_public_path__ + "assets/0faeb0861bdeede63fb08f32cbe02775.png";